import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;

  color: ${({ theme }) => theme.colors.gray[600]};
  background: ${({ theme }) => theme.colors.gray[100]};

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 8px;
  position: relative;

  text-align: end;

  .cardValue {
    margin-top: 8px;

    font-weight: 700;
    font-size: 24px;

    color: ${({ theme }) => theme.colors.orange.primary};
  }

  .gridContainer {
    margin-top: 16px;
  }
`;

export const CardIcon = styled.div`
  position: absolute;
  left: 16px;
  top: -16px;

  height: 56px;
  width: 56px;

  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: ${({ theme }) => theme.colors.orange.primary};

  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.white};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  margin-top: 4px;

  gap: 16px;

  width: 100%;

  p {
    text-align: start;

    font-weight: 500;
    font-size: 14px;
  }

  p + p {
    text-align: center;
  }

  p:nth-child(3) {
    text-align: right;
  }
`;
